import { useEffect, useRef } from 'react'

/**
 * Executa `callback` após `delay` ms sempre que as dependências mudarem,
 * cancelando execuções anteriores.
 */
export const useDebounce = (callback, delay = 500, deps = []) => {
  const savedCallback = useRef(callback)

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    const timer = setTimeout(() => savedCallback.current(), delay)
    return () => clearTimeout(timer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delay, ...deps])
}

export default useDebounce
